import DatePicker from './src/DatePicker';
import { autocompleteDate } from './src/date-input-utils';
export default DatePicker;

export { autocompleteDate };
